/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Export Issues" |
*
* @param {Manual_Qc_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_title = /** @type {((inputs?: Manual_Qc_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter les incidents")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportprobleme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problemi di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вопросы экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problemas de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("輸出に関する問題")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात संबंधी मुद्दे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Questões de exportação")
	return /** @type {LocalizedString} */ ("Export Issues")
});